<template>
  <div class="p-[16px]">
    <template v-if="!(loader || loader2 || loader3 || loader4)">
      <div class="mb-[16px] flex justify-between">
        <div>
          <h2 class="text-[18px] text-[#2b2b2b] font-light">Dashboard</h2>
          <h3 class="mt-1 text-[13px] font-extralight text-[#7b7a7a]">Bienvenue sur le tableau de bord ehr IUGB</h3>
        </div>
        <div class="grow flex items-center justify-end gap-x-[4px]">
          <button class="text-[#2b2b2b] rounded-lg h-[36px] flex gap-x-[6px] items-center border px-6 font-light">
            <LayoutPanelLeft :size="16" strokeWidth="1.3"/>
            Editer dashboard
          </button>
        </div>
      </div>

      <div class="h-[260px] grid grid-cols-3 gap-x-[16px] mb-[16px] text-[#2b2b2b]">
        <employeCard :serie="seriesEmploye"/>
        <departementCard :nb="data?.departements" :data="departements"/>
        <div class="size-full rounded-lg border flex flex-col">
          <div class="p-[12px] grow flex flex-col justify-between font-extralight">
            <div><h2 class="flex items-center gap-x-2">Cumul Congés <Info :size="15" strokeWidth="1.3"/></h2></div>
            <div class="grow flex items-center justify-between">
              <span class="text-[32px] font-light">{{ totalConge }}</span>
              <div class="w-[70%] h-full flex flex-col justify-center">
                <div class="flex items-center gap-x-[8px]">
                  <div class="size-4 rounded-sm bg-[#ee4636]"/> 
                  <span>86</span>
                  <span>Demandes en attentes</span>
                </div>
              </div>
            </div>
          </div>
          <button class="w-full p-3 rounded-b-lg font-extralight bg-[#f6f7fb] flex items-center justify-between">
            <span>Voir détails</span>
            <ArrowRight :size="16" strokeWidth="1.3"/>
          </button>
        </div>
      </div>

      <div class="h-[370px] grid grid-cols-2 gap-x-[16px] mb-[16px] text-[#2b2b2b]">
        <tauxAbsenteisme :serie="workload"/>
        <HrRepartition :serie="hc"/>
      </div>

      <div class="max-h-[370px] grid grid-cols-2 gap-x-[16px] mb-[16px] text-[#2b2b2b] font-extralight">
        <exceptionCard :datas="data.exceptions"/>
        <rangeAgeDonut :datas="range_age"/>
      </div>

      <div class="h-[280px] grid grid-cols-3 gap-x-[16px] text-[#2b2b2b] font-extralight">
        <contratType :serie="contrat_type"/>

        <rangeOrigin :serie="origine"/>

        <div class="size-full rounded-lg border flex flex-col items-center p-[12px]">
          <div class="w-full"><h2 class="flex items-center gap-x-2">Regroupement par ancieneté <Info :size="15" strokeWidth="1.3"/></h2></div>
          <div class="grow w-full grid grid-cols-2 gap-x-[16px]">

            <div class="flex items-center gap-x-[8px]">
                <div class="size-4 rounded-sm bg-[#fa9932]"/> 
                <span>0-4 ans</span>
                <div class="grow h-1/2 self-end border-t border-dashed"/>
                <span>86</span>
            </div>

            <div class="flex items-center gap-x-[8px]">
                <div class="size-4 rounded-sm bg-[#ee4636]"/>
                <span>5-9 ans</span>
                <div class="grow h-1/2 self-end border-t border-dashed"/>
                <span>86</span>
            </div>

            <div class="flex items-center gap-x-[8px]">
                <div class="size-4 rounded-sm bg-[#3474f4]"/>
                <span>10-14 ans</span>
                <div class="grow h-1/2 self-end border-t border-dashed"/>
                <span>86</span>
            </div>

            <div class="flex items-center gap-x-[8px]">
                <div class="size-4 rounded-sm bg-[#24ae75]"/>
                <span>15-19 ans</span>
                <div class="grow h-1/2 self-end border-t border-dashed"/>
                <span>86</span>
            </div>

            <div class="flex items-center gap-x-[8px]">
                <div class="size-4 rounded-sm bg-[#fadc32]"/>
                <span>20-24 ans</span>
                <div class="grow h-1/2 self-end border-t border-dashed"/>
                <span>86</span>
            </div>

            <div class="flex items-center gap-x-[8px]">
                <div class="size-4 rounded-sm bg-[#32a0fa]"/>
                <span>25+ ans</span>
                <div class="grow h-1/2 self-end border-t border-dashed"/>
                <span>86</span>
            </div>

          </div>
        </div>

      </div>
    </template>

    <template v-else>
      <div class="animate-pulse">

        <div class="mb-[16px] flex justify-between items-center h-[36px]">
          <div class="h-full w-[230px] rounded-lg bg-gray-100"/>
            <div class="h-full w-[180px] rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[180px] grid grid-cols-3 gap-x-[16px] mb-[16px]">
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[370px] grid grid-cols-2 gap-x-[16px] mb-[16px]">
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[370px] grid grid-cols-4 gap-x-[16px] mb-[16px]">
          <div class="h-full w-full col-span-3 rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

        <div class="h-[240px] grid grid-cols-3 gap-x-[16px]">
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
          <div class="h-full w-full rounded-lg bg-gray-100"/>
        </div>

      </div>
    </template>
  </div>
</template>

<script>
import API from "../../service/API.js";
import exceptionCard from './dashboard/exception-card.vue';
import rangeAgeDonut from './dashboard/range-age-donut.vue';
import contratType from './dashboard/contrat-type.vue';
import employeCard from "./dashboard/employe-card.vue";
import { LayoutPanelLeft,ArrowRight,Info } from "lucide-vue-next";
import departementCard from "./dashboard/departement-card.vue";
import tauxAbsenteisme from "./dashboard/taux-absenteisme.vue";
import HrRepartition from "./dashboard/hr-repartition.vue";
import rangeOrigin from "./dashboard/range-origin.vue";
export default {
  name: 'DashboardView',
  components: {
    LayoutPanelLeft,
    ArrowRight,
    Info,
    tauxAbsenteisme,
    departementCard,
    employeCard,
    exceptionCard,
    rangeAgeDonut,
    contratType,
    HrRepartition,
    rangeOrigin
  },
  data() {
    return {
      loader: true,
      loader2: true,
      loader3: true,
      loader4: true,
      seriesEmploye:[],
      departements:{},
      origine:[],
      contrat_type:[],
      cdd:0,
      active:0,
      isLoading:true,
      cdi:0,
      stage:0,
      consultant:0,
      range_age:{},
      totalConge:0,
      mapConge : {},
      userConge:[],
      month:['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'],
      filter: 'w',
      other_month: [],
      otherCongeSelector:0,
      data: {},
      hc:[],
      workload:[]
    }
  },
  mounted() {
    this.loadInitialDashboardInfo()
    this.getCongeData();
    this.getotherData();
    this.getHrRepartitionAbsenteisme()
  },
  computed :{
    userName(){
      return (this.$store.getters.lastName ?? "") + " " + (this.$store.getters.firstName ?? "");
    },
    getTime(){
      return (new Date()).toDateString();
    }
  },
  methods: {
    getOtherMonth(tabs){
      this.other_month = tabs.filter((item)=> !item.is_annual);
    },
    loadInitialDashboardInfo() {
      API.post("/getRHDashboard",{ filter: this.filter })
      .then((response)=>{
          this.data = response.data
      })
      .catch((error) => {console.error(error)})
      .finally(()=>{
        this.loader = false
      })
    },
    getCongeData(){
            API.get("/getAllUsersRemainingLeaveDaysSummary")
            .then((data)=>{
                if(data.data.status){
                    this.mapConge = {...data.data.data.filter((item)=>item.is_annual == true)[0]["monthly_leave_used_global"]};
                    this.userConge = data.data["users_by_taken_days"];
                    this.totalConge = data.data.data.filter((item)=>item.is_annual == true)[0]["total_remaining_days"];
                    this.getOtherMonth(data.data.data);
                }
            })
            .catch(e=>{console.log(e)})
            .finally(()=>{
                this.loader2 = false;
            })
    },
    getHrRepartitionAbsenteisme(){
      API.get("getChartsStatistics")
      .then((res)=>{
        if(res.data.status){
          this.hc = res.data.headcount;
          this.workload = res.data.workload;
        }
      })
      .catch()
      .finally(()=>{this.loader3 = false;})
    },
    getotherData(){
      API.get("getFieldStatistics")
      .then((data)=>{
        if(data.data.status){
          this.seriesEmploye = [data.data.data["sexe"]["M"],data.data.data["sexe"]["F"]];
          this.departements = data.data.data["departement"];
          this.origine = [data.data.data["employee_status"]["LOCAL"],data.data.data["employee_status"]["EXPATRIÉ"]]
          this.contrat_type = [data.data.data["contract_type"]["CDI"] ?? 0,
        data.data.data["contract_type"]["CDD"] ?? 0,data.data.data["contract_type"]["STAGE"] ?? 0,data.data.data["contract_type"]["CONSULTANT"] ?? 0]
        
          this.active = data.data.data["status"]["ACTIVE"];
          this.range_age = data.data.data["age_range"];
        }
      })
      .catch()
      .finally(()=>{this.loader4 = false;})
    },
    btnStatus(status) {
      return status ? "bg-[#3c41e9] text-white" : "bg-white text-[#3c41e9]";
    },
  }
}

</script>